// Wallet-switch/tx-send chain ref, deliberately id-only: full chain
// metadata (RPC urls, currency, explorers) belongs to the wagmi config's
// viem chains, not here.
type Chain = { id: number };

// Ethereum Mainnet.
export const L1: Chain = { id: 1 };

// zkSync Era Mainnet (0x144).
export const ZK: Chain = { id: 324 };
